// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './vuex'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
// import store from './vuex'

Vue.prototype.$axios = axios
axios.defaults.baseURL = 'https://reaact.cin.ufpe.br'
axios.defaults.withCredentials = true

axios.interceptors.request.use(function (request) { // interceptor para inserir token nas requisições
  var auth = store.getters['getUserInfo']
  if (auth) {
    request.headers.Authorization = `Bearer ${auth.token}`
  }
  return request
}, function (error) {
  return Promise.reject(error)
})

const options = {
  confirmButtonColor: '#84bac7',
  cancelButtonColor: '#ff7674'
}

Vue.config.productionTip = false
Vue.use(VueSweetalert2, options)
Vue.component('v-icon', Icon)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store
})



// WEBPACK FOOTER //
// ./src/main.js